import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Grid,
  makeStyles,
  useMediaQuery,
  createTheme,
} from "@material-ui/core";
import accountActions from "../redux/actions/accountActions";
import StarIcon from "../assets/images/svg/star.svg";
import { shouldRenderComponent } from "../shared/util/ComponentAuth";
import { formatLoyaltyPoints } from "../shared/util/loyaltyHelper";
import { getFullPath } from "../config/retailerConfig";
import { getProgramDetails }  from "../service/myloyalty_services";

function SpendablePointsHeader({ props, site_Config }) {
  const retailerConfig = useSelector((state) => state.config.retailerConfig);
  const theme = createTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const user = useSelector((state) => state.user);
  const token = localStorage.getItem("token");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(user?.userDetails);

  const headerBlockConfig = props.components.find(
    (component) => component.block_type === "HeaderBlock"
  );
  const headerConfig = headerBlockConfig.header_set[0];
  const authHeader = headerBlockConfig.auth_visibility;
  const pointsUnit = site_Config?.loyaltyPoints_display ?? "POINTS";

  useEffect(() => {
    if (!user.points) {
      dispatch(accountActions.updateUserSpendablePoints(retailerConfig.retailer, retailerConfig));
    }
    setUserInfo(JSON.parse(localStorage.getItem("userData")));
  }, []);

  const useStyles = makeStyles((theme) => ({
    container: {
      backgroundImage: `url(" ${
        isMobile ? headerConfig?.mobile_header : headerConfig?.desktop_header
      }")`,
      backgroundPosition: "bottom",
      display: "flex",
      justifyContent: `${headerConfig.header_position}`,
      height: `${headerConfig.header_heigth}`,
      gap: "48px",
      padding: isMobile ? "50px 32px" : "100px 64px",
    },
    account: {
      maxWidth: "1200px",
      maxHeight: "280px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "16px",
    },
    loginLogo: {
      maxWidth: "628px",
      height: "160px",
      objectFit: "contain",
      // Mobile & mini ipad < 600px
      [theme.breakpoints.down("xs")]: {
        width: "180px",
        height: "80px",
      },
    },
    program_text: {
      fontSize: "24px",
      fontWeight: 400,
      lineHeight: "38.4px",
      textAlign: "center",
      fontFamily: site_Config?.font_family
        ? site_Config?.font_family
        : "Switzer",
      color: `${headerConfig.freeblock_text_color}`,
    },
    signUpBtn_text: {
      color: `${headerConfig.button_text_color}`,
      background: `${headerConfig.button_color}`,
      outline: "none",
      padding: "16px 32px",
      fontSize: "18px",
      fontWeight: "700",
      fontFamily: site_Config?.font_family
        ? site_Config?.font_family
        : "Switzer",
      width: "168px",
      maxWidth: "168px",
      height: "70px",
      boxShadow: "none",
      borderRadius: "240px",
      lineHeight: "20.8px",
      textTransform: "capitalize",
      marginTop: "10px",

      "&:hover": {
        boxShadow: "none",
        backgroundColor: `${headerConfig.button_color}`,
      },
      "&:focus": {
        boxShadow: "none",
        backgroundColor: `${headerConfig.button_color}`,
        outline: "none",
      },
      "&:focus-visible": {
        outline: "none",
      },

      [theme.breakpoints.down("xs")]: {
        width: "100%",
        padding: "1.2rem 1.6rem",
      },
    },
    accountName: {
      color: "#fff",
      textAlign: "center",
      fontSize: "28px",
      fontFamily: "Switzer",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "42px",
    },
    accountInfo: {
      borderRadius: "24px",
      padding: "10px",
      // background: "#fff",
      color: "#fff",
      height:  "205px",
      justifySelf: "center",
    },
    starImage: {
      float: "left",
      marginTop: "40px",
      marginLeft: "14px",
      width: isMobile ? "50px" : "",
      height: isMobile ? "50px" : "",
    },
    accntPoints: {
      maxWidth: "1200px",
      float: "left",
      textAlign: "left",
      marginLeft: "28px",
      marginTop: "14px",
    },
    uploadReceiptbtn: {
      color: `${headerConfig.button_text_color}`,
      background: `${headerConfig.button_color}`,
      borderRadius: "var(--radius-2xl, 240px);",
      border: `1px solid var(--border-border-brand, ${headerConfig.button_color})`,
      boxShadow: "0px 2px 4px 0px rgba(107, 114, 128, 0.12), 0px 3px 5px 0px rgba(107, 114, 128, 0.15)",

      display: "flex",
      justifySelf: "center",
      padding: "8px 48px",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--space--md, 16px)",
      marginTop: isMobile ? "50px" : "0px",
      textTransform: "none",

      "&:hover": {
        boxShadow: "none",
        backgroundColor: `${headerConfig.button_color}`,
      },
      "&:focus": {
        boxShadow: "none",
        backgroundColor: `${headerConfig.button_color}`,
        outline: "none",
      },
      "&:focus-visible": {
        outline: "none",
      },

      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    pointsHeader: {
      fontSize: "var(--h1, 136px)",
      fontStyle: "normal",
      fontFamily: "Switzer",
      fontWeight: 800,
      lineHeight: "122px",
      textAlign: "center",
      display: "flex",
      gap: "var(--space--2xl, 48px);",
      [theme.breakpoints.down("md")]: {
        fontSize: "var(--h1, 80px)",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "var(--h1, 42px)",
      },
    },
    availabletxt: {
      fontSize: "18px",
      fontFamily: "Switzer",
      fontWeight: 400,
      lineHeight: "27px",
      color: "#fff",
    },
  }));

  const classes = useStyles();
  if (!shouldRenderComponent(authHeader)) {
    return null;
  }
  return (
    <>
      {(authHeader === "authenticated" || authHeader === "both") && token && (
        <Grid
          item
          xs={12}
          className={classes.container}
          style={{ textAlign: `${headerConfig.header_position}` }}
        >
          <div
            className={classes.account}
            style={{
              fontFamily: site_Config?.font_family
                ? site_Config?.font_family
                : "Switzer",
            }}
          >
            <div className={classes.accountName}>
              Hi {" "}
              {userInfo !== undefined && userInfo !== null
                ? userInfo?.firstName + ", your point balance is"
                : user?.userDetails?.firstName + ", your point balance is"}
            </div>
            <div className={classes.accountInfo}>
                <h1 className={classes.pointsHeader}>
                  {formatLoyaltyPoints(user.points, pointsUnit)}
                </h1>
            </div>
            <div>
              {user.points > 0 && (
                  <Button variant="contained" className={classes.uploadReceiptbtn}
                    onClick={() => {
                      const anchorId = headerConfig.upload_anchor_id;
                      const targetElement = document.getElementById(anchorId);
                      if (targetElement) {
                        window.scrollTo({ top: targetElement.offsetTop - 200, behavior: 'smooth' });
                      }
                    }}
                  >
                    <span>{headerConfig.upload_button_text}</span>
                  </Button>
              )}
            </div>
          </div>
        </Grid>
      )}
      {(authHeader === "unauthenticated" || authHeader === "both") &&
        !token && (
          <Grid
            item
            xs={12}
            className={classes.container}
            style={{ textAlign: `${headerConfig.header_position}` }}
          >
            <div style={{ maxWidth: "720px", height: "342px" }}>
              <img
                className={classes.loginLogo}
                alt={
                  headerConfig?.logo_alt_text
                    ? headerConfig?.logo_alt_text
                    : "logo"
                }
                src={headerConfig.logo}
              />
              <p className={classes.program_text}>
                {headerConfig.freeblock_text}
              </p>
              <Button
                onClick={() =>
                  navigate(getFullPath("signup"))
                }
                variant="contained"
                className={classes.signUpBtn_text}
              >
                <span style={{ marginRight: "10px" }}>
                  {headerConfig.button_text}
                </span>
                <svg
                  width="24"
                  height="21"
                  viewBox="0 0 24 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.0977 11.5034L14.6602 19.9409C14.0273 20.6265 12.9199 20.6265 12.2871 19.9409C11.6016 19.3081 11.6016 18.2007 12.2871 17.5679L17.8242 11.978H1.6875C0.738281 11.978 0 11.2397 0 10.2905C0 9.39404 0.738281 8.60303 1.6875 8.60303H17.8242L12.2871 3.06592C11.6016 2.43311 11.6016 1.32568 12.2871 0.692871C12.9199 0.00732422 14.0273 0.00732422 14.6602 0.692871L23.0977 9.13037C23.7832 9.76318 23.7832 10.8706 23.0977 11.5034Z"
                    fill={headerConfig.button_text_color}
                  />
                </svg>
              </Button>
            </div>
          </Grid>
        )}
    </>
  );
}
export default SpendablePointsHeader;
